var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48708 11.182L5.84054 12.1147C5.94443 12.1559 6.06225 12.1402 6.15172 12.0732L15.3223 5.20833L8.03071 12.76C7.96655 12.8265 7.93406 12.9173 7.94153 13.0094L8.23756 16.6593C8.28524 17.2473 9.03319 17.4662 9.3904 16.9968L11.1825 14.6419L14.5327 16.1909C15.0909 16.449 15.7447 16.126 15.879 15.5259L18.7197 2.82953C18.8978 2.03368 18.0693 1.38964 17.342 1.75848L3.37923 8.83901C2.3907 9.34029 2.45668 10.7737 3.48708 11.182Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3ad4778c0499afeefee4bfbb5303b4d5.svg";
export { ForwardRef as ReactComponent };